import { RouteRecordRaw } from 'vue-router'

const surveysRoutes: RouteRecordRaw[] = [
  {
    path: '/surveys/reports',
    name: 'surveys.reports',
    component: () => import('@/modules/operations/views/Surveys/SurveyReportsIndex.vue'),
    meta: {
      pageTitle: 'Survey Reports',
      breadcrumbs: ['Survey Reports']
    }
  },
  {
    path: '/surveys/reports/create',
    name: 'surveys.reports.create',
    component: () => import('@/modules/operations/views/Surveys/SurveysEdit.vue'),
    meta: {
      pageTitle: 'Add Survey Report',
      breadcrumbs: ['Survey Reports', 'Add Report']
    }
  },
  {
    path: '/surveys/:id/edit',
    name: 'surveys.edit',
    component: () => import('@/modules/operations/views/Surveys/SurveysEdit.vue'),
    meta: {
      pageTitle: 'Edit Survey',
      breadcrumbs: ['Surveys', 'Edit']
    }
  },
  {
    path: '/surveys/:id/show',
    name: 'surveys.show',
    component: () => import('@/modules/operations/views/Surveys/SurveysShow.vue'),
    meta: {
      pageTitle: 'Survey Details',
      breadcrumbs: ['Surveys', 'Details']
    }
  },
  // Legacy redirects
  {
    path: '/surveys',
    redirect: { name: 'surveys.reports' }
  },
  {
    path: '/surveys/create',
    redirect: { name: 'surveys.reports.create' }
  }
]

export default surveysRoutes
